import React from "react";
import { injectIntl } from "react-intl";
import ScenarioBar from "../../components/ScenarioBar";

function Scenario2Context4() {
	const activeScenario = 2;

	return (
		<div className="h-100 bg-preguntas-5">
			<div className="container-fluid pt-4 h-100">
				<div className="row h-100">
					<div className="col d-flex justify-content-center align-items-center" />
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario2Context4);